import { request } from '@umijs/max';

// 查询ticket信息
export async function getTicketListService(data: any) {
  return request('/bcare/ticket/list', {
    method: 'POST',
    data,
  }).then((res) => {
    return {
      total: res.total,
      list: res.list,
    };
  });
}

export async function getEmergTypeListService() {
  return request('/bcare/ticket/emergency').then((res) => {
    if (res?.appEmergencys?.length) {
      return (res?.appEmergencys || [])?.map((item: any) => ({
        ...item,
        label: item.emergencyName,
        value: item.emergencyId,
      }));
    }
  });
}

export async function getServiceTypeListService(params: any) {
  return request(`/bcare/ticket/serviceType`, {
    params,
  }).then((res) => {
    return (res?.serviceTypes || []).map((item: any) => ({
      key: item.serviceTypeId,
      title: item.serviceTypeName,
      value: item.serviceTypeId,
      isLeaf: false,
      ...item,
    }));
  });
}

export async function createTicketService(data: any) {
  return request('/bcare/ticket/create', {
    method: 'POST',
    data,
  });
}

export async function createTicketByAiccService(data: any) {
  return request('/bcare/ticket/createByAicc', {
    method: 'POST',
    data,
  });
}

// 查询成员列表数量
export async function getMemberListCntService(params: any) {
  const { custId, ...restParams } = params;
  return request(`/bcare/member/list/qty/${custId}`, {
    params: restParams,
  });
}

// 查询成员列表
export async function getServiceNumberListService(params: any) {
  const { custId, ...restParams } = params;
  return request(`/bcare/member/memberlist/${custId}`, {
    params: restParams,
  });
}

// 查询castType列表
export async function getCaseTypeListService() {
  return request('/bcare/ticket/caseType').then((res) => {
    if (res?.caseTypeVoList?.length) {
      return (res?.caseTypeVoList || [])?.map((item: any) => ({
        label: item.caseTypeName,
        value: item.caseType,
      }));
    }
  });
}

// 查询TT单详情
export async function getCaseDetailService(params: any) {
  return request(`/bcare/ticket/caseDetail`, {
    params,
  }).then((res) => {
    return {
      ...res?.caseDto,
      taskDetailDtoList: res?.taskDetailDtoList.map(
        (item: any) => item.taskDetailDto,
      ),
    };
  });
}

// 查询配置项接口
export async function getSysparam(params: any) {
  return request(`/bcare/sysparam`, {
    params,
  });
}

// 校验是否改约
export async function caseCheckAppointmentService(data: any) {
  return request('/bcare/tm/case/appointment/check', {
    method: 'POST',
    data,
  });
}

// 查询改约时间片
export async function caseAppointmentSlotService(data: any) {
  return request('/bcare/tm/case/appointment/slot', {
    method: 'POST',
    data,
  });
}

// case改约提交
export async function caseAppointmentSubmitService(data: any) {
  return request('/bcare/tm/case/appointment/submit', {
    method: 'POST',
    data,
  });
}

// 查询TT单安装环节
export async function getCaseProcessService(params: any) {
  return request(`/bcare/tm/ticket/caseProcess`, {
    params,
  });
}

// 查询TT单维修人员信息
export async function getAppointmentDetailService(params: any) {
  return request(`/bcare/tm/ticket/caseAppointmentDetail`, {
    params,
  });
}
